import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

interface MaintenanceState {
  active: boolean;
  message: string;
  loading: boolean;
}

export function useMaintenanceMode(): MaintenanceState {
  const [state, setState] = useState<MaintenanceState>({ active: false, message: "", loading: true });

  useEffect(() => {
    let mounted = true;
    const timeout = setTimeout(() => {
      if (mounted) setState((s) => ({ ...s, loading: false }));
    }, 5000);

    (async () => {
      try {
        const { data } = await supabase
          .from("app_settings")
          .select("maintenance_mode, maintenance_message")
          .eq("id", "00000000-0000-0000-0000-000000000001")
          .single();
        if (mounted && data) {
          setState({ active: data.maintenance_mode, message: data.maintenance_message ?? "", loading: false });
        } else if (mounted) {
          setState((s) => ({ ...s, loading: false }));
        }
      } catch {
        if (mounted) setState((s) => ({ ...s, loading: false }));
      } finally {
        clearTimeout(timeout);
      }
    })();
    return () => { mounted = false; clearTimeout(timeout); };
  }, []);

  return state;
}
